module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1030-4a60aaccd61f52c84c03f1527cfd318d.png";